import { MapPin, MessageCircle, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PublicPage, H2, P } from "@/components/PublicPage";
import { BUSINESS, waLink } from "@/lib/site";

export default function Contact() {
  return (
    <PublicPage testid="contact-page" overline="Kontak / Bantuan" title="Hubungi Kami">
      <P>Butuh bantuan terkait Mas Tofa AI? Tim kami siap membantu melalui WhatsApp.</P>

      <div className="rounded-2xl border border-slate-200 bg-white p-6">
        <p className="font-heading text-lg font-semibold text-slate-900">{BUSINESS.name}</p>

        <div className="mt-4 flex items-start gap-3 text-slate-600">
          <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" />
          <div>
            <p className="text-sm font-medium text-slate-900">Alamat</p>
            <p className="text-sm" data-testid="contact-address">
              {BUSINESS.address.line1}, {BUSINESS.address.line2}, {BUSINESS.address.line3}
            </p>
          </div>
        </div>

        <div className="mt-4 flex items-start gap-3 text-slate-600">
          <MessageCircle className="mt-0.5 h-5 w-5 shrink-0 text-blue-600" />
          <div>
            <p className="text-sm font-medium text-slate-900">WhatsApp Admin</p>
            <p className="text-sm" data-testid="contact-whatsapp-number">{BUSINESS.whatsappDisplay}</p>
          </div>
        </div>

        <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-cta">
          <Button className="mt-6 w-full rounded-full bg-[#25D366] py-6 text-base font-semibold text-white hover:bg-[#1ebe5b] active:scale-95 transition-transform sm:w-auto sm:px-8">
            <MessageCircle className="mr-2 h-5 w-5" /> Chat WhatsApp Admin
          </Button>
        </a>
      </div>

      <H2>Jam Operasional</H2>
      <div className="flex items-center gap-2 text-slate-600">
        <Clock className="h-4 w-4 text-slate-400" />
        <P>Kami berusaha membalas pesan secepatnya pada jam kerja.</P>
      </div>
    </PublicPage>
  );
}
